/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'sometimes' }, { id: 'no' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-styling-products"
      progress={72}
      field="hairstyleStylingProducts"
      setter="setHairstyleStylingProducts"
      ns="hairstyleStylingProducts"
      imageName="hairstyleStylingProducts"
      options={OPTIONS}
    />
  );
}

export default Page;
